var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMaximize = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  style: {
    isolation: "isolate"
  },
  viewBox: "0 0 20 20"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_NnXEtQGf71iUTzD6gGihmU6QuVZkOgKH"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_NnXEtQGf71iUTzD6gGihmU6QuVZkOgKH)"
}, /*#__PURE__*/React.createElement("path", {
  id: "$",
  fill: "#000",
  d: "M2 18h6l2 2H0V10l2 2zM18 2h-6l-2-2h10v10l-2-2z"
}))));
export default SvgMaximize;